package com.essntl.uikit.components.datepicker

import androidx.compose.material3.DatePickerColors
import androidx.compose.material3.DatePickerDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import com.essntl.uikit.theme.esColorScheme

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun rememberDatePickerColors(): DatePickerColors {
    val esColorScheme = MaterialTheme.esColorScheme

    return DatePickerDefaults.colors(
        containerColor = esColorScheme.bgSecondary,
        titleContentColor = esColorScheme.textPrimary,
        headlineContentColor = esColorScheme.textPrimary,
        weekdayContentColor = esColorScheme.textPrimary,
        subheadContentColor = esColorScheme.textPrimary,
        yearContentColor = esColorScheme.textPrimary,
        currentYearContentColor = esColorScheme.textPrimary,
        selectedYearContentColor = esColorScheme.textContrast,
        selectedYearContainerColor = esColorScheme.primary,
        dayContentColor = esColorScheme.textPrimary,
        disabledDayContentColor = esColorScheme.textDisabled,
        selectedDayContentColor = esColorScheme.textContrast,
        disabledSelectedDayContentColor = esColorScheme.textDisabled,
        selectedDayContainerColor = esColorScheme.primary,
        disabledSelectedDayContainerColor = esColorScheme.primary,
        todayContentColor = esColorScheme.textPrimary,
        todayDateBorderColor = esColorScheme.borderPrimary,
        dayInSelectionRangeContentColor = esColorScheme.textContrast,
        dayInSelectionRangeContainerColor = esColorScheme.primary,
    )
}